import { useQuery } from '@apollo/client';
import { LOAD_METRIC_DEFINITION_BY_ID } from '../gqlSchemes/getMetricDefinitionById';


const useLoadMetricDefinitionById = (id, patientId) => {
  const { data, loading, error } = useQuery(
    LOAD_METRIC_DEFINITION_BY_ID,
    {
      fetchPolicy: 'no-cache',
      variables: {
        page: 0,
        perPage: 20,
        id,
        patientId
      }
    }
  );

  if (error) console.error(error);

  return {
    data,
    components: data?.metric?.metricDefinition?.metricDefinitionById?.components,
    loading,
    error
  };
};

export default useLoadMetricDefinitionById;